var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25732 6.41699C7.25732 6.72803 7.14941 6.98828 6.88281 7.24219L2.08398 11.9458C1.89355 12.1362 1.65869 12.2314 1.37939 12.2314C0.820801 12.2314 0.36377 11.7808 0.36377 11.2222C0.36377 10.9365 0.478027 10.6826 0.6875 10.4731L4.87061 6.41064L0.6875 2.35449C0.478027 2.15137 0.36377 1.89111 0.36377 1.61182C0.36377 1.05957 0.820801 0.602539 1.37939 0.602539C1.65869 0.602539 1.89355 0.697754 2.08398 0.888184L6.88281 5.5918C7.14307 5.83936 7.25732 6.09961 7.25732 6.41699Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.0e76a666da412f814945bf4f435357db.svg";
export { ForwardRef as ReactComponent };